// cardAnimate.js
export function cardAnimate() {
    if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;

    gsap.registerPlugin(ScrollTrigger);

    function initAnimations() {
        const containers = document.querySelectorAll(".card-animate");
        if (!containers.length) return;

        containers.forEach(container => {
            const children = Array.from(container.children);
            if (!children.length) return;

            // Will-change activeren vóór de animatie
            children.forEach(el => (el.style.willChange = "transform, opacity"));

            const tl = gsap.timeline({
                defaults: { ease: "power2.out", duration: 0.6 },
                paused: true,
                onComplete: () => {
                    // Reset will-change en inline styles
                    children.forEach(el => {
                        el.style.willChange = "auto";
                    });
                    gsap.set(children, { clearProps: "transform,opacity" });
                },
            });

            tl.from(children, {
                y: 30,
                opacity: 0,
                stagger: 0.15,
            });

            ScrollTrigger.create({
                trigger: container,
                start: "top 85%",
                once: true, // ✅ maar één keer afspelen
                onEnter: () => tl.play(),
                invalidateOnRefresh: true,
            });
        });

        // Refresh nadat alles geladen is + korte delay
        setTimeout(() => ScrollTrigger.refresh(), 250);
    }

    if (document.readyState === "complete") {
        initAnimations();
    } else {
        window.addEventListener("load", initAnimations);
    }
}

// accordionAnimate.js
export function accordionAnimate() {
    if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;
    gsap.registerPlugin(ScrollTrigger);

    const groups = document.querySelectorAll(".accordion-group");
    if (!groups.length) return;

    groups.forEach(group => {
        const accordions = group.querySelectorAll(".accordion");
        if (!accordions.length) return;

        gsap.from(accordions, {
            y: 20,
            opacity: 0,
            duration: 0.6,
            ease: "power2.out",
            stagger: 0.1,
            scrollTrigger: {
                trigger: group,
                start: "top 85%",
                once: true
            }
        });
    });
}